/**
 * Axolotea Hero Animation
 * Alternates between drinks view and decorative view
 */

class AxoloteaHero {
  constructor(element) {
    this.hero = element;
    this.phrases = this.hero.querySelectorAll('.axolotea-hero__phrase');
    this.currentPhrase = 0;
    this.phraseInterval = 3000; // Switch phrase every 3 seconds
    this.phraseTimer = null;

    if (this.phrases.length === 0) return;

    this.init();
  }

  init() {
    // Start phrase alternation
    this.startPhraseAlternation();

    // Pause on hover
    this.hero.addEventListener('mouseenter', () => this.pause());
    this.hero.addEventListener('mouseleave', () => this.resume());
  }

  nextPhrase() {
    // Remove active class from current phrase
    this.phrases[this.currentPhrase].classList.remove('axolotea-hero__phrase--active');

    // Move to next phrase
    this.currentPhrase = (this.currentPhrase + 1) % this.phrases.length;

    // Add active class to new phrase (triggers convergence animation)
    this.phrases[this.currentPhrase].classList.add('axolotea-hero__phrase--active');
  }

  startPhraseAlternation() {
    this.phraseTimer = setInterval(() => {
      this.nextPhrase();
    }, this.phraseInterval);
  }

  pause() {
    if (this.phraseTimer) {
      clearInterval(this.phraseTimer);
      this.phraseTimer = null;
    }
  }

  resume() {
    if (!this.phraseTimer) {
      this.startPhraseAlternation();
    }
  }
}

// Initialize all hero sections
function initAxoloteaHeroes() {
  const heroes = document.querySelectorAll('.axolotea-hero');
  heroes.forEach(hero => {
    new AxoloteaHero(hero);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAxoloteaHeroes);
} else {
  initAxoloteaHeroes();
}

// Re-initialize on Shopify section load (theme editor)
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.axolotea-hero')) {
      initAxoloteaHeroes();
    }
  });
}
